import React, { useMemo, useState } from 'react'
import { Link } from 'react-router-dom'
import IPInput from '../../../../../components/IPInput'
import Table from '../../../../../components/Table'
import { INotFoundSpecialPriceCodeResponse } from '../../ProductsWithNoSpecialPrice/models/models'

// SAP bayi kodları 10 haneye sıfırla doldurulmuş gelir (0000123456); arama baştaki sıfırlar olmadan yapılır.
export const normalizeDealerCode = (code?: string) => (code || '').trim().replace(/^0+/, '')

interface Props {
  productCode: string
  companyName: string
  companyCode: number
  records: INotFoundSpecialPriceCodeResponse[]
}

/**
 * "Ürün Bilgisi Sorgulama" ekranındaki Eksik Bayi modalı. Kayıtlar "Özel Fiyatı Olmayan Ürünler"
 * raporuyla aynı servisten (admin/NotFoundSpecPriceList) gelir: bayinin bu ürün için düştüğü
 * özel fiyat kodunda TableProductPrices kaydı yoksa bayi listede yer alır.
 */
export default function MissingSpecialPriceDealers({ productCode, companyName, companyCode, records }: Props) {
  const [dealerSearch, setDealerSearch] = useState('')
  const searchCode = normalizeDealerCode(dealerSearch)

  const filteredRecords = useMemo(
    () => (searchCode ? records.filter(r => normalizeDealerCode(r.BayiKodu).includes(searchCode)) : records),
    [records, searchCode]
  )

  const exactMatch = searchCode ? records.find(r => normalizeDealerCode(r.BayiKodu) === searchCode) : undefined

  const tableColumns = useMemo(
    () => [
      {
        Header: 'Bayi Kodu',
        accessor: 'dealerCode',
      },
      {
        Header: 'Fiyat Kodu',
        accessor: 'priceCode',
      },
      {
        Header: 'Özel Fiyat Kodu (Tanımsız)',
        accessor: 'specialPriceCode',
      },
      {
        Header: 'Cari Tip Kodu',
        accessor: 'dealerType',
      },
    ],
    []
  )

  const tableData = useMemo(
    () =>
      filteredRecords.map(item => ({
        dealerCode: normalizeDealerCode(item.BayiKodu),
        priceCode: item.FiyatKodu,
        specialPriceCode: <b style={{ color: 'orange' }}>{item.OzelFiyatKodu}</b>,
        dealerType: item.CariTip,
      })),
    [filteredRecords]
  )

  return (
    <div>
      <div className='d-flex justify-content-between align-items-center flex-wrap mb-3'>
        <span>
          <b>{productCode}</b> ürünü için <b>{companyName}</b> şirketinde <b>{records.length}</b> bayinin özel fiyat
          kodunda fiyat tanımı bulunmuyor.
        </span>
        <Link
          target='_blank'
          to={`/admin/ProductOperation/ProductsWithNoSpecialPrice?product=${productCode}&company=${companyCode}`}
        >
          Rapor sayfasında aç
        </Link>
      </div>
      <div className='row'>
        <div className='col-md-4'>
          <IPInput
            type='text'
            className='form-control'
            name='dealerSearch'
            placeholder='Bayi Kodu ile Ara'
            value={dealerSearch}
            onChange={e => setDealerSearch(e.target.value)}
          />
        </div>
        <div className='col-md-8 d-flex align-items-center'>
          {searchCode &&
            (exactMatch ? (
              <b style={{ color: 'red' }}>
                {searchCode} bayisi için fiyat tanımı YOK (Özel Fiyat Kodu: {exactMatch.OzelFiyatKodu})
              </b>
            ) : (
              <span>
                <b style={{ color: 'green' }}>{searchCode} bayisi eksik listesinde değil, fiyat tanımı mevcut.</b>{' '}
                <small style={{ color: '#888' }}>(Bayi bu şirkette kayıtlı değilse de bu sonuç görünür.)</small>
              </span>
            ))}
        </div>
      </div>
      <div className='mt-3'>
        <Table columns={tableColumns} data={tableData} currentPage={0} />
      </div>
    </div>
  )
}
